
import { Component, Prop, Vue } from 'vue-property-decorator'

interface PrimaryPhotoType {
  caption?: string
  url: {
    masterImage: string
  }
}

@Component
export default class PrimaryPhoto extends Vue {
  @Prop({ required: true })
    photo: PrimaryPhotoType

  @Prop({ default: true })
    lazy: boolean
}
